<template>
  <div>
    <GiftsHospitalityUser v-if="!isReviewer" />
    <b-tabs v-else content-class="pt-3">
      <b-tab title="Declarar" active>
        <GiftsHospitalityUser />
      </b-tab>
      <b-tab title="Analisar">
        <GiftsHospitalityAdmin />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GiftsHospitalityUser from "./GiftsHospitalityUser.vue";
import GiftsHospitalityAdmin from "./GiftsHospitalityAdmin.vue";

export default {
  name: "GiftsHospitalityHub",
  components: {
    GiftsHospitalityUser,
    GiftsHospitalityAdmin,
  },
  computed: {
    ...mapGetters(["profile"]),
    isCompanyRoot() {
      return this.profile && this.profile.role === "company-root";
    },
    isDesignatedReviewer() {
      if (!this.profile || !this.profile.companyData) {
        return false;
      }

      const modules = this.profile.companyData.modules || {};
      const moduleConfig = modules.giftshospitality || {};
      const reviewers = Array.isArray(moduleConfig.reviewers)
        ? moduleConfig.reviewers
        : [];
      const currentUserId = Number(this.profile._id);
      return reviewers.map(Number).includes(currentUserId);
    },
    isReviewer() {
      return this.isCompanyRoot || this.isDesignatedReviewer;
    },
  },
};
</script>
